/**
 * @deprecated
 * business logic moved to /shared/lib/localStorage namespace
 */
export enum LOCAL_STORAGE {
  EmailSignIn = 'email',
  AuthToken = 'authToken',
  User = 'user',
  CodeCountdownStartedAt = 'codeCountdownStartedAt',
  CodeTriesLeft = 'codeTriesLeft',
  UserInfoStep = 'userInfoStep',
  Code = 'code',
  Tab = 'tab',
  Nickname = 'nickname',
}
